<template>
  <div ref="actionSendEmail">
    <sFormItem
      ref="emailRecipients"
      class="row-mails"
      :label="$t('Automation.EmailRecipients')"
      prop="EmailRecipients"
      :rules="rules.EmailRecipients">
      <div class="mails-component">
        <div
          v-if="emails && emails.length"
          class="flex flex-wrap mt-1">
          <sChip
            v-for="(item, mailIndex) in emails"
            :key="mailIndex"
            background="var(--v-secondary__green_chosen-base)"
            class="py-1 px-2 mb-1 mr-1"
            :class="{'pl-0': item.blockDomen}"
            :color="item.blockDomen ? 'var(--secondary__red)' : 'var(--text-color)'"
            :data-qa="`mail-${mailIndex}`"
            :disabled="disabled">
            <div class="flex">
              <InfoIconWithTooltip
                v-if="item.blockDomen"
                class="mr-2"
                :content="$t('Common.mailDomenBlocked')"
                type-tooltip="dark"/>
              <div>{{ item.email }}</div>
              <div
                v-if="!disabled"
                class="ml-2 pointer"
                @click="deleteMail(mailIndex)">
                <sIcon
                  color="var(--text-color)"
                  :data-qa="`mail-${mailIndex}-close`"
                  size="10"
                  type="cross"/>
              </div>
            </div>
          </sChip>
        </div>
        <textarea
          ref="emails"
          class="s-textarea__inner mails-component__input"
          :disabled="disabled"
          style="min-height: 120px;"
          @input="val => text = val.target.value"
          @keydown.enter="getMail(text)"
          @paste.prevent.stop="evt => getMail(evt.clipboardData.getData('text/plain'))"/>
      </div>
    </sFormItem>
    <sFormItem
      :label="$t('Automation.ContactRecipients')"
      prop="ContactRecipients"
      :rules="rules.ContactRecipients">
      <sSelect
        class="width-100 mt-1"
        clearable
        data-qa="condition-props-list"
        :disabled="disabled"
        filterable
        multiple
        :placeholder="$t('Common.Select')"
        :value="valueMutable.ContactRecipients"
        @update:value="sendValue('ContactRecipients', $event)">
        <sOption
          v-for="sprItem in tenderContactPersons"
          :key="`tender-contact-${sprItem.key}`"
          :data-qa="`tender-contact-${sprItem.key}`"
          :disabled="disabled"
          :label="sprItem.label"
          :value="sprItem.key">
          <div>
            <div>{{ sprItem.label }}</div>
            <div
              v-if="sprItem.description"
              class="font-size-12 opacity-8">
              {{ sprItem.description }}
            </div>
          </div>
        </sOption>
      </sSelect>
    </sFormItem>
    <SendTo
      class="mb-2"
      :value.sync="valueMutable"/>
    <sFormItem
      :label="$t('Automation.Theme')"
      prop="Subject"
      :rules="rules.Subject">
      <div class="flex">
        <sInput
          ref="input"
          clearable
          :disabled="disabled"
          :placeholder="$t('Automation.Subject')"
          :value="valueMutable.Subject"
          @update:value="sendValue('Subject', $event)"/>
        <div
          class="ml-2 my-auto">
          <AutomationTags
            v-if="!disabled"
            @addedTag="addedTag('Subject', $event)"/>
        </div>
      </div>
    </sFormItem>
    <sFormItem
      :label="$t('Automation.Text')"
      prop="Message"
      :rules="rules.Message">
      <div class="flex">
        <sInput
          ref="text"
          clearable
          :disabled="disabled"
          max-length="7"
          :placeholder="$t('Automation.MailMessage')"
          rows="3"
          type="textarea"
          :value="valueMutable.Message"
          @update:value="sendValue('Message', $event)"/>
        <div
          class="ml-2">
          <AutomationTags
            v-if="!disabled"
            @addedTag="addedTag('Message', $event)"/>
        </div>
      </div>
    </sFormItem>
  </div>
</template>
<script>
import AutomationTags from 'components/automation/AutomationTags.vue'
import SendTo from 'components/automation/actions/commonComponents/SendTo.vue'
import InfoIconWithTooltip from 'components/common/elements/InfoIconWithTooltip.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()
import automations from 'mixins/automations'

/**
 * Автоматизация. Действие отправка письма
 */
const pattern = new RegExp('(?:["\'`\\s]*|(?<name>\\w+(?:[,\\.:\\s]+\\w+)*)?["\'`:\\s<]+)(?<mail>[\\w\\-\\_\\.]+@[\\w\\-\\.]+\\.[a-zA-Z]+\\b)', 'gm')
export default {
  name: 'sendEmail',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      rules: {
        EmailRecipients: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            const regex = new RegExp(/^\s*([A-Za-z0-9_\-.'])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,10})\s*$/)
            if (that.emails) {
              that.emails.forEach(emailRecipient => {
                if (!regex.test(emailRecipient.email)) {
                  callback(new Error(that.$t('Tenders.MailRules', {mail: ` (${emailRecipient.email})`})))
                }
                if (emailRecipient.blockDomen) {
                  callback(new Error(that.$t('Common.mailDomenBlocked')))
                }
              })
            }
            /*if (!that.emails?.length) {
              callback(new Error(that.$t('Tenders.EmptyOrErrorEmailAdress')))
            }*/
            const isEmptyCheck = !that.valueMutable?.SendToResposible
            && !that.valueMutable?.SendToTenderParticipants
            && !that.valueMutable?.SendToInvitedParticipants
            && !that.valueMutable?.SendToApprovers
            if (!that.valueMutable?.ContactRecipients?.length && !that.valueMutable?.EmailRecipients?.length && isEmptyCheck) {
              callback(new Error(that.$t('Automation.EmptyEmailRecipients')))
            }

            callback()
          },
        },
        ContactRecipients: {},
        SendToResposible: {},
        SendToTenderParticipants: {},
        SendToInvitedParticipants: {},
        SendToApprovers: {},
        Subject: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable?.Subject?.trim()) {
              callback(new Error(that.$t('Validate.Required')))
            }
            const errorTags = that.$_checkCorrectTagsOnString(that.valueMutable?.Subject)
            if (errorTags?.length) {
              callback(new Error(`${that.$t('Automation.VariablesNotExists')}: ${errorTags.join(', ')}`))
            }
            callback()
          },
        },
        Message: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable?.Message?.trim()) {
              callback(new Error(that.$t('Validate.Required')))
            }
            const errorTags = that.$_checkCorrectTagsOnString(that.valueMutable?.Message)
            if (errorTags?.length) {
              callback(new Error(`${that.$t('Automation.VariablesNotExists')}: ${errorTags.join(', ')}`))
            }
            callback()
          },
        },
      },
      text: null,
    }
  },
  methods: {
    deleteMail(index) {
      const result = this.$_.cloneDeep(this.emails)
      result.splice(index, 1)
      this.emails = result
    },
    checkBlockDomen(mail) {
      return ['ru', 'рф', 'рус', 'su'].some(s => mail.endsWith(s))
    },
    /**
     * Метод вызывается перед отправкой формы автоматизации
     * Имя метода стандартное и не изменное
     */
    async beforeApply() {
      await this.getMail()
    },
    /**
     * Анализ строки и поиск данных по почте
     */
    async getMail(text) {
      const textForParse = `${text || this.text}`
      if (!textForParse) {
        return
      }
      const parseResult = {
        ret: [...textForParse.matchAll(pattern)],
        substitution: textForParse.replace(pattern, '')
      }
      const result = this.$_.cloneDeep(this.emails) || []
      var ret = parseResult.ret.filter((i) => !result.find(mailObject => mailObject.email === i[0]))

      if (ret?.length) {
        ret.forEach(emailObject => {
          const mail = emailObject.groups.mail
          if (!this.emails.find(i => i.email === mail)) {
            result.push({
              email: mail
            })
          }
        })
      }
      parseResult.substitution = parseResult.substitution == 'null' || !parseResult.substitution ? '' : parseResult.substitution

      const substitution = parseResult.substitution.trim()
      const isEmpty = substitution.replace(/[\n\s]/g, '').length === 0
      if (isEmpty) {
        this.text = this.$refs.emails.value = ''
      } else {
        this.text = this.$refs.emails.value = substitution
      }
      this.emails = result
      this.$nextTick(() => {
        this.$refs.emailRecipients.validate()
      })
    },
    addedTag(field, tag) {
      this.sendValue(field, `${this.valueMutable[field] || ''} {${tag}}`)
    },
    sendValue(field, props) {
      const result = this.$_.cloneDeep(this.value)
      const parameters = this.$_.cloneDeep(this.valueMutable)

      parameters[field] = props
      result.parameters = JSON.stringify(parameters)

      this.$emit('update:value', result)
    }
  },
  computed: {
    tenderContactPersons() {
      return this.$store.getters.getTenderContactPersons.map(i => ({
        key: i.contactId,
        label: i.name,
        description: i.login
      }))
        .sort((a,b) => a.label?.localeCompare(b.label))
    },
    valueMutable: {
      get() {
        const defaultMode = {
          EmailRecipients: '',
          Subject: '',
          Message: '',
          SendToResposible: false,
          SendToTenderParticipants: false,
          SendToInvitedParticipants: false,
          SendToApprovers: false,
          ContactRecipients: []
        }
        if (!this.value?.parameters) {
          return defaultMode
        }
        try {
          const convertPropToBool = (propValue) => { return propValue === true || propValue === 'true' }
          const result = JSON.parse(this.value.parameters) || {}
          result.SendToResposible = convertPropToBool(result.SendToResposible)
          result.SendToTenderParticipants = convertPropToBool(result.SendToTenderParticipants)
          result.SendToInvitedParticipants = convertPropToBool(result.SendToInvitedParticipants)
          result.SendToApprovers = convertPropToBool(result.SendToApprovers)
          result
          return result
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Automation.ErrorActionParameters'),
            showClose: true,
            progress: true,
          })
          return defaultMode
        }
      },
      set(value) {
        const result = this.$_.cloneDeep(this.value)
        result.parameters = JSON.stringify(value)
        this.$emit('update:value', result)
      }
    },
    emails: {
      get() {
        if (!this.valueMutable?.EmailRecipients?.length) {
          return []
        }
        return this.valueMutable.EmailRecipients
          .filter(m => m.trim())
          .map(i => ({
            blockDomen: this.checkBlockDomen(i.trim()),
            email: i.trim()
          }))
      },
      set(newValue) {
        this.sendValue('EmailRecipients', newValue.map(m => m.email))
      }
    }
  },
  created() {
    if (!this.tenderContactPersons?.length) {
      tender_api.tenderContactPersons()
    }
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
  components: {
    SendTo,
    AutomationTags,
    InfoIconWithTooltip
  }
}
</script>
<style lang="scss">
.sFormItem.is-error .mails-component {
  border-color: var(--color-error) !important;
}
.sFormItem {
  &.is-error .mails-component__input {
    color: var(--color-error);
    border-color: var(--color-main-green) !important;
  }
}
.mails-component__input:disabled {
  opacity: 0.5;
  border-color: var(--v-secondary__green_not_active-base) !important;
}
.mails-component {
  border: 2px solid transparent !important;
  border-radius: 8px;
  padding: 0 2px 2px 2px;
}
.row-mails {
  .v-input__slot {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}
</style>
